import MonacoEditor from "./editor";
import MonacoDiffEditor from "./diff";
export * from "./types";
export { MonacoEditor as default, MonacoDiffEditor };
//# sourceMappingURL=index.js.map